Office.onReady()

import 'intl'
import 'intl/locale-data/jsonp/en'

import office from '../../src/office/office'
import { appointmentEventLoft } from '../../src/services/loft'

;(async () => { 
  await office
    .setOffice()

  Office.actions.associate("appointmentEventLoft", appointmentEventLoft)
})()
